/**
 * Created by zqy on 2018/8/20 0020.
 */
import { loginByUsername, logout, fetchAdminPermissions } from '@/api/Users/admin'
import { getToken, setToken, removeToken,getLoginInfo,setLoginInfo,removeLoginInfo} from '@/utils/auth'


const user = {
  state: {
    login: getLoginInfo() || {name:'',showname:'',avatar:'',role:''},
    token: getToken(),
    permissions: [],//权限
    menus:[],//菜单
    setting: {
      articlePlatform: []
    }
  },

  mutations: {
    SET_LOGIN: (state, info) => {
      state.login = info
      setLoginInfo(info);
    },
    SET_TOKEN: (state, token) => {
      state.token = token
      setToken(token)
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
  },

  actions: {
    // 用户名登录
    LoginByUsername({ commit }, userInfo) {
      const username = userInfo.login_name.trim()
      return new Promise((resolve, reject) => {
        loginByUsername(username,userInfo.password,userInfo.uuid,userInfo.captcha).then(res => {
          console.log(res)
          if(res.code===0 && res.data && res.data.token){
            let data=res.data
            commit('SET_TOKEN',data.token)
            let loginInfo={
              name:username,
              showname:data.nickName,
              role:data.roleName,
              isremember:userInfo.isrememberpsw
            }
            if(userInfo.isrememberpsw){
              loginInfo.psw=userInfo.password
            }
            commit('SET_LOGIN',loginInfo)
            resolve(res)
          }else{
            resolve(res)
          }
        }).catch(error => {
          reject(error)
        })
        // commit('SET_TOKEN', "4472z6deu76nI4ZqJaQXPRpDaU1oxO+1RQWKr31Bz3UQXEb6AKIrfoL/2cKidaJ4P3AeONt6jYS/imw8YTolg70")
        // let loginInfo={
        //   name:username,
        //   showname:"管理员",
        //   role:"角色名称",
        // }
        // commit('SET_LOGIN',loginInfo)
        // resolve({code:0})
      })
    },
    // 获取权限信息
    GetAdminPermissions({ commit, state }) {
      return new Promise((resolve, reject) => {
        fetchAdminPermissions(state.token).then(response => {
          if (response.code!==0) { // 由于mockjs 不支持自定义状态码只能这样hack
            reject(response.msg)
          }
          if (response.data) { // 验证返回的data是否是一个非空数组
            commit('SET_PERMISSIONS',response.data?response.data:[])
          } else {
            reject('管理权限不能为空!')
          }
          // commit("SET_MENUS",response.menu?response.menu:[])

          resolve(response)

        }).catch(error => {
          reject(error)
        })
        // let response={ perms:['admin']}
        // commit('SET_PERMISSIONS',response.perms?response.perms:[])
        // resolve(response)
      })
    },
    // 第三方验证登录
    // LoginByThirdparty({ commit, state }, code) {
    //   return new Promise((resolve, reject) => {
    //     commit('SET_CODE', code)
    //     loginByThirdparty(state.status, state.email, state.code).then(response => {
    //       commit('SET_TOKEN', response.data.token)
    //       setToken(response.data.token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '')
        removeToken()

        commit('SET_MENUS', [])

        commit('SET_PERMISSIONS',[])

        let loginInfo=state.login;
        if(loginInfo && loginInfo.isremember){
          loginInfo.showname=''
          loginInfo.role=''
        }else{
          loginInfo={
            name:'',
            psw:'',
            showname:'',
            role:'',
            isremember:false
          }
        }
        commit('SET_LOGIN',loginInfo)
        //removeLoginInfo();
        resolve()

        /*logout(state.token).then(() => {
         commit('SET_TOKEN', '')
         commit('SET_MENUS', [])
         removeToken()
         resolve()
         }).catch(error => {
         reject(error)
         })*/
      })
    },

  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js